/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {Tooltip} from "@insite/mobius/index";
import React, {useEffect, useRef, useState} from "react";
import {css} from "styled-components";

interface Props {
    maxWidth?: number;
    characters?: number;
    text: string;
}

const TextOverflow = ({maxWidth, characters, text}: Props) => {
    const [overflow, setOverflow] = useState(false);
    const [computedMaxWidth, setComputedMaxWidth] = useState(0);
    const ref = useRef(null);
    const ref1 = useRef(null);

    let elementCSS = css``;

    useEffect(() => {
        if (!ref.current && !ref1.current) {
            return;
        }

        if (characters && text.length > characters) {
            const element1Rect = (ref1.current as any)?.getBoundingClientRect();

            setComputedMaxWidth(element1Rect.width);
            setOverflow(true);

            return;
        }

        const elementRect = (ref.current as any)?.getBoundingClientRect();
        if (maxWidth && elementRect.width > maxWidth) {
            setComputedMaxWidth(maxWidth);
            setOverflow(true);

            return;
        }

        setOverflow(false);
    }, [ref, ref1]);

    if (overflow) {
        elementCSS = css`
          max-width: ${computedMaxWidth}px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: inline-block;
          position: relative;
        `;
    }

    const element = (
        <>
            <StyledWrapper as="span" ref={ref} css={elementCSS}>{text}</StyledWrapper>
            <StyledWrapper as="span"
                           ref={ref1}
                           css={css`position:absolute;background: transparent;color: transparent;z-index: -1;height: 0;`}>
                {text.substring(0, characters ? (characters + 3) : 0)}
            </StyledWrapper>
        </>
    );

    if (!overflow) {
        return element;
    }

    return <Tooltip triggerComponent={element} text={text} {...{placement: "top"}} />;
};

export default TextOverflow;
